import { render, staticRenderFns } from "./doge.vue?vue&type=template&id=e4b9cf48&scoped=true"
import script from "./doge.vue?vue&type=script&lang=js"
export * from "./doge.vue?vue&type=script&lang=js"
import style0 from "./doge.vue?vue&type=style&index=0&id=e4b9cf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b9cf48",
  null
  
)

export default component.exports